import React from 'react';
import SireList from 'components/Tvendo/Common/Sire/SireList';
import { ConstantPermissions } from 'contexts/useConstant';

export default function SalesSire() {
  return (
    <SireList
      entity="sale/sire"
      title="Ventas SIRE"
      permission={ConstantPermissions.SALE_ORDERS_INDEX}
    />
  );
}
